import { render, staticRenderFns } from "./TicketMessageList.vue?vue&type=template&id=4ef7d784"
import script from "./TicketMessageList.vue?vue&type=script&lang=js"
export * from "./TicketMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports